import React from 'react';
import { Box, Typography, Card, CardContent, Chip } from '@mui/material';
import { Work as WorkIcon } from '@mui/icons-material';

const JobDetailsCard = ({ job }) => {
  if (!job) return null;

  return (
    <Card sx={{ mb: 3, border: '1px solid #e0e0e0' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <WorkIcon sx={{ color: 'primary.main', mr: 1 }} />
          <Typography variant="h6" fontWeight="bold">
            Job Details
          </Typography>
        </Box>
        
        <Typography variant="h6" sx={{ mb: 1 }}>
          {job.title}
        </Typography>
        
        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
          {job.recruiter_organizations?.[0]?.organisation?.name || 'Company'}
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
          <Chip
            label={job.location}
            variant="outlined"
            size="small"
          />
          <Chip
            label={job.salary}
            variant="outlined"
            size="small"
          />
        </Box>
        
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Category: {job.category_details?.name}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default JobDetailsCard;